import {ValueObject} from '@s-ui/domain'
import parseQueryString from '@s-ui/js/lib/string/parse-query-string.js'
import toQueryString from '@s-ui/js/lib/string/to-query-string.js'

import {QueryParamSharedValueObject} from './QueryParamSharedValueObject.js'

export class QueryStringSharedValueObject extends ValueObject {
  #params

  constructor({params}) {
    super()
    this.#params = params
  }

  static createWithSanitize({config, queryString}) {
    const sanitizedQueryString = QueryStringSharedValueObject.sanitize({config, queryString})
    const paramsMap = new Map()

    sanitizedQueryString.forEach(queryParam => {
      paramsMap.set(queryParam.key, queryParam.value)
    })

    return new QueryStringSharedValueObject({
      params: Object.fromEntries(paramsMap)
    })
  }

  static sanitize({config, queryString}) {
    const queryParams = parseQueryString(queryString, {allowSparse: true})

    return Object.entries(queryParams).map(([key, value]) => {
      return QueryParamSharedValueObject.createWithSanitize({config, key, value})
    })
  }

  get queryString() {
    return toQueryString(this.#params, {addQueryPrefix: true, skipNulls: true})
  }

  get value() {
    return this.#params
  }
}
